export default "/images/vendor/@coreui/icons/svg/flag/cif-sl.svg?999c484f1640bf427a37809febde6a81";